import gql from 'graphql-tag';
import apollo from 'src/features/apollo';

const query = gql`
query AvgVotesForRequestType($requestTypeId: Int!) {
  avgVoteByChannelForRequestType(requestTypeId: $requestTypeId) {
     channel,
     avgVote
  }
}`;

function getAvgIndicativeVotesForRequestType(requestTypeId) {
  return apollo.client.query({
    query,
    variables: {
      requestTypeId: parseInt(requestTypeId, 10),
    },
    fetchPolicy: 'network-only',
  }).then((data) => data.data.avgVoteByChannelForRequestType);
}

export default getAvgIndicativeVotesForRequestType;
